export default "__VITE_ASSET__116f38e9__"